<div class="chip-set-container" [class.chip-set-container--nowrap]="nowrap">
  <button
    *ngFor="let chip of chips; trackBy: trackByFn"
    role="button"
    class="cta-sm chip-set-button"
    [class.chip-set-button--huge]="huge"
    [class.active]="active.includes(chip.value)"
    (click)="onSelect(chip.value)"
  >
    {{ chip.label | translate }}
  </button>
</div>
